; (function (navigation) {

    navigation.SubscriptionHandler = class SubscriptionHandler {

        constructor() {
            this.subscriptions = [];
        }

        addSubscription(subscription) {
            this.subscriptions.push(subscription);
        }

        removeSubscriber(subscription) {
            var removeIndex = this.subscriptions.findIndex(s => {
                return subscription === s;
            });

            if (removeIndex !== -1) {
                this.subscriptions = this.subscriptions.slice(removeIndex, 1);
            }
        }

        notify(data) {
            if (this.subscriptions.length > 0) {
                _.each(this.subscriptions, function (s) {
                    s.callback(s.target, data);
                });
            }
        }

    };

    navigation.Subscription = class Subscription {

        constructor(target, callback) {
            this.target = target;
            this.callback = callback;
        }

    };

}(window.getours.Navigation = window.getours.Navigation || {}));